module.exports = __webpack_public_path__ + "launcher-b3f2c338649a913cfd44.svg";